import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { getComposedDescriptionColor } from '@app/product.utils';
import * as rolesUtils from '@app/role.utils';
import * as utils from '@app/utils';
import * as fromFollows from '@core/reducers/follow.reducer';
import * as fromRoot from '@core/reducers/root.reducer';
import { select, Store } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';

@Component({
  selector: 'app-products-list-item',
  templateUrl: './products-list-item.component.html',
  styleUrls: ['./products-list-item.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductsListItemComponent implements OnInit {
  @Input()
  product;

  @Input()
  selectedProducts;

  @Output()
  selected = new EventEmitter();

  me$ = this.store.pipe(select(fromRoot.getMe));
  follows$ = this.store.pipe(select(fromFollows.getFollowEntities));

  follow;
  me;
  role;
  countryId;
  _alive = true;

  @HostListener('click', ['$event'])
  hostClick(event) {
    // this.store.dispatch(
    //   new ProductCountryActions.LoadByProductMirror(this.product.id)
    // );

    // this.store.dispatch(
    //   new ProductShipmentActions.LoadByProductMirror(this.product.id)
    // );
    this.select(this.id, event);
  }

  @HostBinding('class.selected')
  get selectedProduct() {
    return (
      this.product &&
      this.selectedProducts &&
      this.selectedProducts.map(p => p.id).includes(this.product.id)
    );
  }

  get designCompleted() {
    return this.product && this.product.designStatus === 2;
  }

  get providerCompleted() {
    return this.product && this.product.ProviderId;
  }

  get description() {
    return this.product && this.product.description;
  }

  get regionalDescription() {
    if (this.follow && this.follow.type === 'VESTUARIO') {
      return getComposedDescriptionColor(this.product);
    } else {
      return (
        (this.product && this.product.descriptionColor) || 'Sin descripción'
      );
    }
    // return this.product && this.product.descriptionColor;
  }

  get hasPictures() {
    return (
      this.product && this.product.Pictures && this.product.Pictures.length
    );
  }

  get isSet() {
    return (
      (this.product &&
        !this.product.setId &&
        this.product.metadata &&
        this.product.metadata.productType &&
        this.product.metadata.productType.toUpperCase().includes('SET')) ||
      (this.product &&
        !this.product.setId &&
        this.product.metadata &&
        this.product.metadata.productTypeClothing &&
        this.product.metadata.productTypeClothing.toUpperCase().includes('SET'))
    );
  }

  get isComponent() {
    return (
      (this.product &&
        this.product.setId &&
        this.product.metadata &&
        this.product.metadata.productType &&
        this.product.metadata.productType
          .toUpperCase()
          .includes('COMPONENTE')) ||
      (this.product &&
        this.product.setId &&
        this.product.metadata &&
        this.product.metadata.productTypeClothing &&
        this.product.metadata.productTypeClothing
          .toUpperCase()
          .includes('COMPONENTE'))
    );
  }

  get mainPictureUrl() {
    const images = utils.fetchImage(this.product);

    if (images) {
      return images;
    } else {
      return 'assets/no-picture.png';
    }
  }

  get id() {
    return this.product && this.product.id;
  }

  get code() {
    return this.product && this.product.code;
  }

  isMac() {
    return navigator.platform.indexOf('Mac') > -1;
  }

  select(id, event) {
    const { metaKey, ctrlKey, shiftKey } = event;
    this.selected.emit({
      id,
      metaKey: this.isMac() ? metaKey : ctrlKey,
      shiftKey
    });
  }

  get productCountry() {
    return (
      this.product &&
      this.product.ProductCountries &&
      this.me &&
      this.product.ProductCountries.find(
        pc =>
          pc.CountryId === (this.me && this.me.CountryId) &&
          pc.businessUnit === (this.me && this.me.businessUnit)
      )
    );
  }

  constructor(private store: Store<any>) {}

  ngOnInit() {
    this.me$.pipe(takeWhile(() => this._alive)).subscribe(me => {
      this.me = me;
      this.role = me && me.role;
      this.countryId = me && me.CountryId;
    });

    this.follows$.pipe(takeWhile(() => this._alive)).subscribe(follow => {
      this.follow = follow[this.product.FollowId];
    });
  }

  get isCountryBuyer() {
    return rolesUtils.isCountryUser(this.role);
  }

  get unitsPerBox() {
    return (
      this.product && this.product.metadata && this.product.metadata.master
    );
  }

  get totalShipmentUnits() {
    if (this.productCountry && this.productCountry.Shipments) {
      return this.productCountry.Shipments.reduce((sum, sh) => {
        return sum + (sh.units || 0);
      }, 0);
    } else {
      return 0;
    }
  }
}
